const requiredFirebaseEnv = (name) => {
  const value = process.env[name];

  if (!value) {
    throw new Error(`Missing required Firebase build variable: ${name}`);
  }

  return value;
};

const firebaseConfig = {
  firebase: {
    apiKey: requiredFirebaseEnv("REACT_APP_FIREBASE_API_KEY"),
    authDomain: requiredFirebaseEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
    projectId: requiredFirebaseEnv("REACT_APP_FIREBASE_PROJECT_ID"),
    storageBucket: requiredFirebaseEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
    messagingSenderId: requiredFirebaseEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
    appId: requiredFirebaseEnv("REACT_APP_FIREBASE_APP_ID"),
    measurementId: requiredFirebaseEnv("REACT_APP_FIREBASE_MEASUREMENT_ID"),
  },
  webPush: {
    publicKey: process.env.REACT_APP_WEB_PUSH_PUBLIC_KEY || "",
  },
};

export default firebaseConfig;
